import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";
import { moodHappyIcon, moodNeutralIcon, moodSadIcon, moodSmileIcon } from "../../MapMarkerIcons/MapMarkerIcons";


export function DisponibleEnRutasViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const personal_id = record[0] as string;
    const apellido = record[3] as string;
    const nombre = record[4] as string;
    const puesto = record[5] as string;
    const horas_disponibles_str = record[7] as string;
    const horas_disponibles = horas_disponibles_str === "" ? null : Number.parseFloat(horas_disponibles_str);

    let color = theme.colors.green[6];
    let disponibles = '';
    let icon = moodSmileIcon;

    if (horas_disponibles === null) {
        color = theme.colors.red[8];
        disponibles = '(! Sin rutas asignadas)';
        icon = moodNeutralIcon;
    } else if (horas_disponibles > 0) {
        color = theme.colors.pink[6];
        disponibles = `(${horas_disponibles} horas disponibles)`;
        icon = moodSmileIcon;
    } else if (horas_disponibles < 0) {
        color = theme.colors.orange[6];
        disponibles = `(${horas_disponibles} horas sobreasignadas)`;
        icon = moodSadIcon;
    } else if (horas_disponibles === 0) {
        color = theme.colors.green[6];
        disponibles = `(Todas las horas asignadas)`;
        icon = moodHappyIcon;
    }


    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - ${disponibles}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: color,
    }

    return markerProps;
}